export const STATUS = {
	PENDING: 0,
	APPROVED: 1,
	REJECTED: 2,
	PAID: 3,
};
